import { createSimpleThemedComponent } from '../util/createThemedComponent';
export var Table = createSimpleThemedComponent({
    variant: 'table',
    as: 'table',
});
//# sourceMappingURL=Table.js.map